import { extendTheme } from "@chakra-ui/react";

import { ICustomTheme } from "../types/ICustomTheme";

export const theme = extendTheme({
  colors: {
    primary: {
      50: "#e6f5ff",
      100: "#b3e0ff",
      200: "#80ccff",
      300: "#4db8ff",
      400: "#1aa3ff",
      500: "#0099ff",
      600: "#007acc",
      700: "#005c99",
      800: "#003d66",
      900: "#001f33",
    },
  },
  styles: {
    global: {
      li: {
        listStylePosition: "inside",
      },
      a: {
        color: "cyan.400",
        textDecoration: "underline",
        _hover: {
          textDecoration: "none",
        },
      },
      "ol, ul": {
        padding: "revert",
        margin: "revert",
      },
    },
  },
  hugeLettersSpacing: false,
}) as ICustomTheme;
